import {
  AfterViewInit,
  Component,
  ComponentRef,
  Input,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
@Component({
  selector: 'app-drawer',
  templateUrl: './drawer.component.html',
  styleUrls: ['./drawer.component.scss']
})
export class DrawerComponent implements AfterViewInit {
  @ViewChild('drawerContent', { read: ViewContainerRef, static: true }) contentRef!: ViewContainerRef;
  @Input() name!: string;

  childComponentRef!: ComponentRef<any>;
  onClose!: (result?: any) => void;

  isOpen = false;

  ngAfterViewInit(): void {
    // Delay to allow CSS transition
    setTimeout(() => this.isOpen = true, 10);
  }

  close() {
    this.isOpen = false;
    setTimeout(() => {
      if (this.onClose) this.onClose();
    }, 300); // Wait for animation to finish
  }
}

